module.exports = __webpack_public_path__ + "static/media/printer.30309b37.svg";